import { INativeType } from "./INativeType";

export const NativeType: INativeType = {
    Section: '00000000-0000-0000-0000-000000000001',
    Serie: '00000000-0000-0000-0000-000000000002',
    Subserie: '00000000-0000-0000-0000-000000000003',
    User: '00000000-0000-0000-0000-000000000004',
    Role: '00000000-0000-0000-0000-000000000005',
    Profile: '00000000-0000-0000-0000-000000000006',
    Country: '00000000-0000-0000-0000-000000000007',
    Department: '00000000-0000-0000-0000-000000000008',
    City: '00000000-0000-0000-0000-000000000009',
    Contact: '00000000-0000-0000-0000-000000000010',
    Holiday: '00000000-0000-0000-0000-000000000011',
    Gender: '00000000-0000-0000-0000-000000000012',
    EthnicGroup: '00000000-0000-0000-0000-000000000013',
    DocumentaryType: '00000000-0000-0000-0000-000000000014',
    ArchivoxDocument: '00000000-0000-0000-0000-000000000015',
    Expediente: '00000000-0000-0000-0000-000000000016',
    InputFile: '00000000-0000-0000-0000-000000000017',
    OutputFile: '00000000-0000-0000-0000-000000000018',
    InternalComunication: '00000000-0000-0000-0000-000000000019',
    IdentificacionType: '00000000-0000-0000-0000-000000000020',
    ApplicationDocument: '00000000-0000-0000-0000-000000000021',
    IsNativeType: (value: string) => {
        return value === NativeType.Section
            || value === NativeType.Serie
            || value === NativeType.Subserie
            || value === NativeType.User
            || value === NativeType.Role
            || value === NativeType.Profile
            || value === NativeType.Country
            || value === NativeType.Department
            || value === NativeType.City
            || value === NativeType.Contact
            || value === NativeType.Holiday
            || value === NativeType.Gender
            || value === NativeType.EthnicGroup
            || value === NativeType.DocumentaryType
            || value === NativeType.ArchivoxDocument
            || value === NativeType.Expediente
            || value === NativeType.InputFile
            || value === NativeType.OutputFile
            || value === NativeType.InternalComunication
            || value === NativeType.IdentificacionType
            || value === NativeType.ApplicationDocument;
    }
}